<template>
  <div class="mt-5">
    <h6 class="text-dark">Responde esta pregunta</h6>
    <div class="mt-4">
      <b-form-textarea
        :state="question.valid"
        :disabled="loading"
        class="input-question mt-3"
        v-model="answer.val"
        placeholder="Escribe tu respuesta..."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
      <b-button @click="sendAnswer" style :disabled="loading" class="mt-3 mb-5 b-yellow">
        <b-spinner v-if="loading" small></b-spinner>
        <i v-if="!loading" class="fas fa-paper-plane"></i> Responder
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      answer: {
        val: "",
        valid: null
      }
    };
  },
  props: {
    question: Object
  },
  methods: {
    verifyInputs() {
      let answer = this.answer.val.trim();

      if (answer != "" && answer != null && answer != undefined) {
        this.answer.valid = true;
      } else {
        this.answer.valid = false;
      }
    },
    sendAnswer() {
      this.loading = true;
      this.verifyInputs();
      if (this.answer.valid) {
        let url =
          "course/" +
          this.question.curse_id +
          "/question/" +
          this.question.id +
          "/answers";
        this.api
          .post(url, {
            data: {
              course_question_id: this.question.id,
              answer: this.answer.val
            }
          })
          .then(({ data }) => {
            this.loading = false;
            if (data.insertion) {
              this.bus.$emit("UpdateQuestions", data.data_return);
              let answers = data.data_return.filter(question => {
                return question.id == this.question.id;
              });
              this.bus.$emit("UpdateAnswers", answers[0].answers);
              this.answer = {
                val: "",
                valid: null
              };
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/CreateAnswer.vue